import { createI18n } from 'vue-i18n';
import { getCurrentLanguage } from '@eureka/language-tool';

export function createI18nInstance(locale?: string) {
  locale = locale || getCurrentLanguage();
  return createI18n({
    legacy: false,
    locale,
    fallbackLocale: 'en',
    messages: {
      en: {
        saveToProject: {
          title: 'Save to Project',
          latestUpdate: 'Latest Update',
          cancel: 'Cancel',
          save: 'Save',
          createFolder: 'Create Project',
          removeSuccess: 'Remove Success',
          addSuccess:
            'Successfully added to the project, you can <a class=\"text-seo-yellow-500 underline\" target=\"_blank\" href=\"/graph/{content}\">click here</a> to view',
        },
      },
      cn: {
        saveToProject: {
          title: '保存到项目',
          latestUpdate: '最新更新',
          cancel: '取消',
          save: '保存',
          createFolder: '创建项目',
          removeSuccess: '移除成功',
          addSuccess:
            '成功添加进项目，你可以<a class=\"text-seo-yellow-500 underline\" target=\"_blank\" href=\"/graph/{content}\">点击此处</a>查看',
        },
      },
      tw: {
        saveToProject: {
          title: '保存到專案',
          latestUpdate: '最新更新',
          cancel: '取消',
          save: '保存',
          createFolder: '建立資料夾',
          removeSuccess: '移除成功',
          addSuccess:
            '已成功添加至專案，你可以<a class=\"text-seo-yellow-500 underline\" target=\"_blank\" href=\"/graph/{content}\">點擊此處</a>查看',
        },
      },
      jp: {
        saveToProject: {
          title: 'プロジェクトに保存',
          latestUpdate: '最新更新',
          cancel: 'キャンセル',
          save: '保存',
          createFolder: 'フォルダーを作成',
          removeSuccess: '削除成功',
          addSuccess:
            'プロジェクトに成功して追加されました。<a class=\"text-seo-yellow-500 underline\" target=\"_blank\" href=\"/graph/{content}\">ここをクリックして</a>表示できます',
        },
      },
    },
  });
}

export const i18n = createI18nInstance();
